import { combineReducers } from "redux";

import { TimelineReducer } from "./timeline/TimelineReducer";
import type { ViewState } from "./ViewState";

export const ViewReducer = combineReducers<ViewState>({
	timeline: TimelineReducer,
});
